import Vue from 'vue'
import Store from '@/store/store.js'
import {
	Graph
} from '@antv/x6';
import {
	DagreLayout
} from '@antv/layout'

Vue.prototype.$Graph = Graph
Vue.prototype.$DagreLayout = new DagreLayout({
	type: 'dagre',
	begin: [10, 10],
	rankdir: 'LR',
	align: undefined,
	ranksep: 30,
	nodesep: 15,
	controlPoints: true,
})

window.systemData = {}
window.systemMethods = {}
Vue.prototype.$systemData = window.systemData
Vue.prototype.$systemMethods = window.systemMethods

window.systemMethods.device = () => {

	let sUserAgent = navigator.userAgent.toLowerCase();
	let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	let bIsMidp = sUserAgent.match(/midp/i) == "midp";
	let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	let bIsAndroid = sUserAgent.match(/android/i) == "android";
	let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	let bIsDingTalk = sUserAgent.match(/dingtalk/i) == "dingtalk";
	//console.log(bIsDingTalk,'bIsDingTalk')
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsDingTalk) {
		if (bIsIphoneOs) {
			return 'ios'
		} else if (bIsAndroid) {
			return 'android'
		} else if (bIsDingTalk) {
			return 'phone'
		} else {
			return 'phone'
		}
	} else {
		return 'pc'
	}
}
window.systemMethods.GMTdate2date = (serialNumber) => {
	const excelBaseDate = new Date(1900, 0, 1);
	const days = serialNumber - 1; // Excel序列号需要减去1
	const targetDate = new Date(excelBaseDate);
	targetDate.setDate(targetDate.getDate() + days);
	const formattedDate = targetDate.getFullYear() + "/" +
		(String(targetDate.getMonth() + 1).padStart(2, '0')) + "/" +
		(String(targetDate.getDate()).padStart(2, '0'));
	return formattedDate;
}

window.systemMethods.hasAuth = (item, field = 'auth') => {
	//console.log(item)
	let auth = item[field]
	if (field != 'auth') {
		auth = auth ? JSON.parse(auth) : auth
	}
	let department = []
	let staff = []
	let user = Store.store.state.system.user
	let parentdepartment = []
	let childerndepartment = []
	let hasauth = false
	if (item.enable == 6) {
		return false
	}
	if (!auth || user.accounttype == 'admin') {
		return true
	}
	for (let i in auth) {
		if (auth[i].length != 0) {
			hasauth = true
		}
	}
	if (!hasauth) {
		return true
	}

	if (auth.department) {
		auth.department.forEach((item) => {
			department.push(parseInt(item.departmentid))
			childerndepartment = window.systemMethods.findchildrenBydepartmentid(
				window.systemData
				.department, item.departmentid)
			parentdepartment = window.systemMethods.findparentBydepartmentid(window
				.systemData
				.department, item.departmentid)

			if (item.departmentid == 3) {
				console.log(childerndepartment, parentdepartment)
			}
			if (item.type == 'children') {
				department = department.concat(childerndepartment)
			}
			if (item.type == 'parent') {
				department = department.concat(parentdepartment)
			}
			if (Array.isArray(user.managedepartment)) {
				let intersection = []
				if (item.type == 'self_manager') {
					department = []
					intersection = user.managedepartment.filter(value => department.includes(value))
				}
				if (item.type == 'parent_manager') {
					department = []
					intersection = user.managedepartment.filter(value => parentdepartment.includes(value))
				}
				if (item.type == 'children_manager') {
					department = []
					intersection = user.managedepartment.filter(value => childerndepartment.includes(value))
				}
				if (intersection.length != 0) {
					staff.push(parseInt(user.id))
				}
			}
		})
	}
	if (auth.staff) {
		auth.staff.forEach((item) => {
			staff.push(parseInt(item.id))
		})
	}
	if (auth.postjob) {
		auth.postjob.forEach((item) => {
			if (item.id == user.detail.postjob) {
				staff.push(parseInt(user.id))
			}
		})
	}
	if (auth.joblevel) {
		auth.joblevel.forEach((item) => {
			if (item.id == user.detail.joblevel) {
				staff.push(parseInt(user.id))
			}
		})
	}
	if (auth.group) {
		auth.group.forEach((item) => {
			if (user.detail.group.includes(item.id)) {
				staff.push(parseInt(user.id))
			}
		})
	}
	department.forEach((item) => {
		window.systemData.staff.forEach((_item) => {
			if (_item.departmentid == item) {
				staff.push(parseInt(_item.id))
			}
		})
	})
	//console.log(item.id,staff,user.id,123)
	return staff.includes(user.id)
	//console.log(department, staff)

}
window.systemMethods.findchildrenBydepartmentid = (departmentlist, departmentid) => {
	let children = []
	for (let i = 0; i < departmentlist.length; i++) {
		if (departmentlist[i].parentid == departmentid) {
			children.push(departmentlist[i].id)
			children = children.concat(window.systemMethods.findchildrenBydepartmentid(departmentlist,
				departmentlist[i].id))
		}
	}
	return children
}
window.systemMethods.findparentBydepartmentid = (departmentlist, departmentid) => {
	let parents = [];
	const object = departmentlist.find(obj => obj.id == departmentid);
	if (!object) {
		return parents
	}
	if (object.parentid !== null) {
		const parent = departmentlist.find(obj => obj.id == object.parentid)
		if (parent) {
			parents.push(parent.id)
			parents = parents.concat(window.systemMethods.findparentBydepartmentid(departmentlist, parent.id))
		}
	}
	return parents
}
window.systemMethods.timestampToDate = (timestamp, onlydate = false) => {
	if (!timestamp) {
		return timestamp
	}
	if (timestamp < 1000000000000) {
		timestamp *= 1000
	}
	let date = new Date(parseInt(timestamp))
	let Y = date.getFullYear() + "-"
	let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-"
	let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " "
	let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
	let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
	let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
	if (onlydate) {
		if (onlydate == 'month') {
			return window.systemMethods.removePrefixAndSuffix((Y + M).trim(), '-', '-')
		}
		if (onlydate == 'year') {
			return window.systemMethods.removePrefixAndSuffix((Y).trim(), '-', '-')
		}
		if (onlydate == 'time') {
			return window.systemMethods.removePrefixAndSuffix((h + m + s).trim(), '-', '-')
		}
		return (Y + M + D).trim()
	} else {

		return (Y + M + D + h + m + s).trim()
	}
}
window.systemMethods.timestampToMonth = (timestamp, type = 'begin') => {
	if (!timestamp) {
		return timestamp
	}
	if (timestamp < 1000000000000) {
		timestamp *= 1000
	}
	let date = new Date(timestamp);
	date.setDate(1); // 设置当月第一天
	date.setHours(0); // 设置为0点
	date.setMinutes(0); // 设置为0分
	date.setSeconds(0); // 设置为0秒
	date.setMilliseconds(0); // 设置为0毫秒
	if (type != 'begin') {
		date.setMonth(date.getMonth() + 1, 1)
	}
	return date.getTime();
}
window.systemMethods.removePrefixAndSuffix = (inputString, prefix, suffix) => {
	if (inputString.startsWith(prefix)) {
		inputString = inputString.slice(prefix.length)
	}
	if (inputString.endsWith(suffix)) {
		inputString = inputString.slice(0, -suffix.length)
	}
	return inputString;
}
window.systemMethods.getflowstatus = (value) => {
	if (value == 0) {
		return '未结束'
	} else if (value == 1) {
		return '已结束'
	} else if (value == 2) {
		return '无流程'
	} else {
		return ''
	}
}
window.systemMethods.urltoArr = (url) => {
	let spliturl = url.split('.')
	console.log(spliturl)
	return [{
		uid: Math.random(),
		url: url,
		name: "图片." + spliturl[spliturl.length - 1],
		path: url,
		type: spliturl[spliturl.length - 1].toUpperCase(),
		status: "success"
	}]
}
window.systemMethods.isemail = (value) => {
	let emailReg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/
	return emailReg.test(value)
}
window.systemMethods.getEmun = (name) => {
	let data = []
	window.systemData.emun.forEach((item) => {
		if (item.field === name) {
			data.push(JSON.parse(JSON.stringify(item)))
		}
	})
	return data
}
window.systemMethods.isCascader = (name) => {
	let data = window.systemMethods.getEmun(name)
	let cascader = false
	data.forEach((item) => {
		if (item.parentid) {
			cascader = true
		}
	})
	return cascader
}
window.systemMethods.formatter = (row, column) => {
	if (!row) {
		return null
	}
	if (column.formatter == 'postjob' || column.formatter == 'joblevel' || column
		.formatter == 'staff' || column.formatter == 'department' || column
		.formatter == 'flowstatus' || column.formatter == 'company') {
		return window.systemMethods['get' + column.formatter](row[column.field])
	} else if (column.formatter == 'datetime') {
		if (row[column.field]) {
			return window.systemMethods.timestampToDate(row[column.field])
		} else {
			return row[column.field]
		}
	} else if (column.formatter == 'date') {
		if (row[column.field]) {
			return window.systemMethods.timestampToDate(row[column.field], true)
		} else {
			return row[column.field]
		}

	} else if (column.formatter == 'year') {
		if (row[column.field]) {
			return window.systemMethods.timestampToDate(row[column.field], "year")
		} else {
			return row[column.field]
		}
	} else {
		if (typeof window.systemMethods['get' + column.formatter] === 'function') {
			return window.systemMethods['get' + column.formatter](row[column.field])
		} else {
			return window.systemMethods.getEmunValue(column.formatter, row[column.field])

		}
	}
}

window.systemMethods.setLocalConfig = (configtype, item, value) => {
	let config = window.localStorage.getItem(window.config.project + '_config')
	if (config) {
		config = JSON.parse(config)
	} else {
		config = {}
	}
	config[configtype] = config[configtype] ? config[configtype] : {}
	config[configtype][item] = value
	window.localStorage.setItem(window.config.project + '_config', JSON.stringify(config))
}
window.systemMethods.getLocalConfig = (configtype, item) => {
	let config = window.localStorage.getItem(window.config.project + '_config')
	if (config) {
		config = JSON.parse(config)
	} else {
		config = {}
	}
	if (config[configtype]) {
		return config[configtype][item]
	} else {
		return null
	}

}

window.systemMethods.arraysAreEqual = (arr1, arr2, order = true) => {
	if (arr1.length !== arr2.length) {
		return false // 长度不同，不相等
	}
	let targetarr1 = []
	let targetarr2 = []
	if (order) {
		targetarr1 = arr1
		targetarr2 = arr2
	} else {
		targetarr1 = arr1.slice().sort()
		targetarr2 = arr2.slice().sort()
	}

	for (let i = 0; i < targetarr1.length; i++) {
		if (targetarr1[i] !== targetarr2[i]) {
			return false // 元素不同，不相等
		}
	}
	return true // 比较通过，相等
}
window.systemMethods.formatNumber = (num) => {
	let _num = num
	if (typeof(_num) == 'string') {
		_num = parseFloat(_num)
	}
	return _num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

window.systemMethods.digitUppercase = (price, showUnit = true) => {
	const fraction = ['角', '分'];
	const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	const unit = [
		['元', '万', '亿'],
		['', '拾', '佰', '仟']
	];
	let num = Math.abs(price);
	// console.log(num,999)
	let s = '';
	let cents = Math.round(num * 100); // 总分数，如 635.03 → 63503

	fraction.forEach((item, index) => {
		let digitValue = Math.floor(cents / (10 ** (1 - index))) % 10;
		// index=0(角): cents/10 再取余10
		// index=1(分): cents/1 再取余10
		s += (digit[digitValue] + item).replace(/零./, '');
	});
	// console.log(s, 999)
	s = s || (showUnit ? '整' : ''); // 根据showUnit决定是否显示“整”
	num = Math.floor(num);

	for (let i = 0; i < unit[0].length && num > 0; i += 1) {
		let p = '';
		for (let j = 0; j < unit[1].length && num > 0; j += 1) {
			p = digit[num % 10] + unit[1][j] + p;
			num = Math.floor(num / 10);
		}
		// 使用showUnit参数来决定是否添加单位
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + (showUnit ? unit[0][i] : '') + s;
	}
	// 在最后处理整字和单位
	s = s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零');
	if (showUnit && s.endsWith('元')) {
		s += '整';
	}
	return s.replace(/^整$/, showUnit ? '零元整' : '');
};

Graph.registerNode(
	'sponser', {
		width: 80,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			// {
			// 	tagName: 'text',
			// 	selector: 'tag',
			// },
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#F56C6C',
				stroke: 'black',
				strokeWidth: 2,
				rx: '50%',
				ry: '50%',
				pointerEvents: 'visiblePainted',
			},
			name: {
				refX: '50%',
				refY: '50%',
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'middle',
				textVerticalAnchor: 'middle',
			},
		},
		ports: {
			groups: {
				out: {
					position: 'right',
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'red',
						},
					},
				},
			},
			items: [{
				id: 'out',
				group: 'out',
			}],
		}
	},
	true,
)
Graph.registerNode(
	'audit', {
		width: 80,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			// {
			// 	tagName: 'text',
			// 	selector: 'tag',
			// },
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#67C23A',
				stroke: 'black',
				strokeWidth: 2,
				rx: '50%',
				ry: '50%',
				pointerEvents: 'visiblePainted',
			},
			name: {
				refX: '50%',
				refY: '50%',
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'middle',
				textVerticalAnchor: 'middle',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
				out: {
					position: 'right',
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'red',
						},
					},
				},
			},
			items: [{
				id: 'in',
				group: 'in',
			}, {
				id: 'out',
				group: 'out',
			}],
		},
	},
	true,
)
Graph.registerNode(
	'end', {
		width: 80,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			// {
			// 	tagName: 'text',
			// 	selector: 'tag',
			// },
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#909399',
				stroke: 'black',
				strokeWidth: 2,
				rx: '50%',
				ry: '50%',
				pointerEvents: 'visiblePainted',
			},
			name: {
				refX: '50%',
				refY: '50%',
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'middle',
				textVerticalAnchor: 'middle',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
			},
			items: [{
				id: 'in',
				group: 'in',
			}],
		},
	},
	true,
)

Graph.registerNode(
	'staff', {
		width: 180,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			{
				tagName: 'image',
				selector: 'eventicon',
			},
			{
				tagName: 'text',
				selector: 'tag',
			},
			{
				tagName: 'text',
				selector: 'name',
			}
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#5F95FF',
				stroke: 'black',
				strokeWidth: 2,
				rx: 10,
				ry: 10,
				pointerEvents: 'visiblePainted',
			},
			avatar: {
				width: 50,
				height: 50,
				refX: 8,
				refY: 6,
				opacity: 1,
				'xlink:href': require('@_system/icon/member.png'),
			},
			eventicon: {
				width: 30,
				height: 25,
				refX: 35,
				refY: 35,
				opacity: 0,
				'xlink:href': require('@_system/icon/event.png'),
			},
			tag: {
				refX: 0.9,
				refY: 0.2,
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'end',
			},
			name: {
				refX: 0.9,
				refY: 0.6,
				fill: '#fff',
				fontSize: 14,
				fontWeight: '800',
				textAnchor: 'end',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
				out: {
					position: 'right',
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'red',
						},
					},
				},
			},
			items: [{
				id: 'in',
				group: 'in',
			}, {
				id: 'out',
				group: 'out',
			}],
		}
	},
	true,
)


Graph.registerNode(
	'logic', {
		width: 180,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			// {
			// 	tagName: 'text',
			// 	selector: 'tag',
			// },
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: 'white',
				stroke: 'black',
				strokeWidth: 2,
				pointerEvents: 'visiblePainted',
			},
			name: {
				refX: '50%',
				refY: '50%',
				fill: 'black',
				fontSize: 14,
				textAnchor: 'middle',
				textVerticalAnchor: 'middle',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
				enable: {
					position: 'right',
					label: {
						position: 'right', // 标签位置
					},
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'black',
						},
					},
				},
				disable: {
					position: 'bottom',
					label: {
						position: 'bottom', // 标签位置
					},
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'white',
						},
					},
				}
			},
			items: [{
				id: 'in',
				group: 'in',
			}, {
				id: 'enable',
				group: 'enable',
				attrs: {
					text: {
						text: '真'
					},
				},
			}, {
				id: 'disable',
				group: 'enable',
				attrs: {
					circle: {
						r: 10,
						magnet: true,
						stroke: 'black',
						strokeWidth: 2,
						fill: 'white',
					},
					text: {
						text: '假'
					}
				},

			}],
		},
	},
	true,
)

Graph.registerNode(
	'inform', {
		width: 180,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			{
				tagName: 'text',
				selector: 'tag',
			},
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#909399',
				stroke: 'black',
				strokeWidth: 2,
				rx: 10,
				ry: 10,
				pointerEvents: 'visiblePainted',
			},
			avatar: {
				width: 60,
				height: 60,
				refX: 8,
				refY: 6,
				opacity: 1,
				'xlink:href': require('@_system/icon/member.png'),
			},
			tag: {
				refX: 0.9,
				refY: 0.2,
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'end',
			},
			name: {
				refX: 0.9,
				refY: 0.6,
				fill: '#fff',
				fontSize: 14,
				fontWeight: '800',
				textAnchor: 'end',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
				out: {
					position: 'right',
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'red',
						},
					},
				},
			},
			items: [{
				id: 'in',
				group: 'in',
			}, {
				id: 'out',
				group: 'out',
			}],
		}
	},
	true,
)

Graph.registerNode(
	'sonflow', {
		width: 180,
		height: 80,
		markup: [{
				tagName: 'rect',
				selector: 'body',
			},
			{
				tagName: 'image',
				selector: 'avatar',
			},
			{
				tagName: 'text',
				selector: 'tag',
			},
			{
				tagName: 'text',
				selector: 'name',
			},
		],
		attrs: {
			body: {
				refWidth: '100%',
				refHeight: '100%',
				fill: '#E6A23C',
				stroke: 'black',
				strokeWidth: 2,
				rx: 10,
				ry: 10,
				pointerEvents: 'visiblePainted',
			},
			avatar: {
				width: 60,
				height: 60,
				refX: 8,
				refY: 6,
				opacity: 1,
				'xlink:href': require('@_system/icon/sonflow.png'),
			},
			tag: {
				refX: 0.9,
				refY: 0.2,
				fill: '#fff',
				fontSize: 14,
				textAnchor: 'end',
			},
			name: {
				refX: 0.9,
				refY: 0.6,
				fill: '#fff',
				fontSize: 14,
				fontWeight: '800',
				textAnchor: 'end',
			},
		},
		ports: {
			groups: {
				in: {
					position: 'left',
					attrs: {
						circle: {
							r: 10,
							magnet: false,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'green',
						},
					},
				},
				out: {
					position: 'right',
					attrs: {
						circle: {
							r: 10,
							magnet: true,
							stroke: 'black',
							strokeWidth: 2,
							fill: 'red',
						},
					},
				},
			},
			items: [{
				id: 'in',
				group: 'in',
			}, {
				id: 'out',
				group: 'out',
			}],
		}
	},
	true,
)